import ajax from "plugins/AjaxService"
import { Draft } from "types/Draft"
import { Production, Solution } from "types/Production"
import { getFarmIdForApi } from "./productions"



/**
 * INDEX
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-34095
 */
async function index(production: Production): Promise<{ data: Solution[] }> {
	const farmId = getFarmIdForApi(production.farmId)
	const prodUuid = production.uuid
	return await ajax.get(
		`farms/${farmId}/productions/${prodUuid}/solutions`
	)
}

/**
 * SHOW
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-34115
 */
async function show(farmId: number, productionUuid: string, solutionUuid: string): Promise<{ data: Solution }> {
	return await ajax.get(
		`farms/${getFarmIdForApi(farmId)}/productions/${productionUuid}/solutions/${solutionUuid}`
	)
}

/**
 * PROMOTE
 * promuove una SOLUTION a DRAFT, creando un nuovo DRAFT con i dati della SOLUTION
 * https://app.clickup.com/30373227/v/dc/wyxbb-20075/wyxbb-35035
 * 
 * @param draftUuid è opzionale, se presente permette di aggiornare un draft esistente invece di crearne uno nuovo
 */
async function promote(production: Production, solUuid: string, description: string = "...", draftUuid?: string): Promise<{ data: Draft }> {
	const farmId = getFarmIdForApi(production.farmId)
	const prodUuid = production.uuid
	return await ajax.post(
		`farms/${farmId}/productions/${prodUuid}/solutions/${solUuid}/promote`,
		{
			productionSolution: {
				draftDescription: description,
				draftUuid: draftUuid,
			}
		}
	)
}

const api = {
	index,
	show,
	promote,
}
export default api